// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"9816b8df","419":"6ae694e2","563":"6f3a1cc2","787":"2be84fa0","942":"5819fcbb"}[chunkId] + ".chunk.js";
};